const VerticalLine = {
    id: 'VerticalLine',
    afterDraw(chart) {
        // eslint-disable-next-line no-underscore-dangle
        if (chart.tooltip?._active?.length) {
            // find coordinates of tooltip
            const [activePoint] = [chart.tooltip._active[0]];
            const { ctx } = chart;
            const { x } = activePoint.element;
            const topY = activePoint.element.y;
            const bottomY = chart.scales.y.bottom;

            // draw vertical line
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, topY);
            ctx.lineTo(x, bottomY);
            ctx.lineWidth = 1.5;
            ctx.strokeStyle = '#3777BC';
            ctx.stroke();
            ctx.restore();
        }
    }
};

export default VerticalLine;
